import uiRouter from '@uirouter/angularjs';

import './tabs.scss';
import template from './tabs.html';

export const TabsComponentModule = angular
    .module('app.components.pageHeader.tabs', [uiRouter])
    .component('tabs', {
        template,
        bindings: {
            tabs: '<',
            onTabChange: '<',
            gtmId: '<',
            isMobile: '<'
        },
        controller: class TabsController {
            constructor($state, $attrs, $scope) {
                'ngInject';

                angular.extend(this, {
                    currentTab: 0,
                    tabState: {},
                    loading: false,
                    themeName: this.theme === 'dark' ? 'dark' : 'light',
                    $state,
                    $attrs
                });

                $scope.$on('$stateChangeStart', (event, toState) => {
                    this.currentTab = this.getTabIndex(toState.name);
                });
            }

            $onInit() {
                this.tabs.forEach((item, index) => {
                    this.tabState[item.state] = index;
                });
                this.currentTab = this.getTabIndex(this.$state.current.name);
            }

            getTabIndex(state) {
                return this.tabState[state];
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/pageHeader/tabs/tabs.js